export const addresses = {
  colorSchemes: "0xEAf918cc3aba362aDFBf6Ce1D95039bF4EbDB259",
  svgHelper: "0xEC6B0295fDb988952652ed75e1EECC3e94237A46",
};
